import * as React from 'react';

// Utils
import { withUserWebView } from '@shopee-user/with-web-view';

// Components
import { AccessibleSpan } from '@shopee-user/shared-customization-ui';

// Constants
import { constants } from '@shopee-user/spx-customization-logic';

// Types
import { WithUserWebViewProps } from '@shopee-user/with-web-view';

type Props = {
  text: string;
  onClick?: () => void;
} & WithUserWebViewProps;

/**
 * Base help button to navigate to help url
 */
const BaseButton = ({ text, onClick, webViewNavigateToUrl }: Props) => {
  if (!text) {
    return null;
  } else {
    return (
      <AccessibleSpan
        onClick={() => {
          if (onClick) {
            onClick();
          }
          webViewNavigateToUrl(constants.SIGNUP_HELP_LINK);
        }}
      >
        {text}
      </AccessibleSpan>
    );
  }
};

/**
 * Use `webViewNavigateToUrl` to navigate to `SIGNUP_HELP_LINK`
 */
export const SignupHelpButton = withUserWebView({})(BaseButton);
